import { useEffect, useMemo, useState } from "react";
import { ButtonFrame, Card, InputDropdown, InputField, PageBodyHeader} from "../../component"
import { UrlTypes, generalObj } from "../../constant/object_types";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { addUser, fetchUserListById } from "../../action/generalFunc";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FiEye, FiEyeOff } from "react-icons/fi";

const AddSubAdmin = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState<generalObj>({
        firstname: "",
        lastname: "",
        username: "",
        mobile: "",
        email: "",
        password: "",
        confirm_password: "",
        admin_level: null,
        secure_entry: true,
        is_supervisor: false
    });

    const adminLevelList:generalObj[] = useMemo(() => [
        {
            id: 1,
            label: "Order Admin",
            value: "order_admin"
        }
    ], []);

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();

    const account = useSelector((state:RootState) => state.account);
    const { id } = useParams();

    useEffect(() => {
        if (!account || !account.isAuthenticated) return;
        
        setModalLoading(false);
    }, [account, setModalLoading]);

    useEffect(() => {
        if (!account || !account.isAuthenticated) return;
        if (id) {
            (async () => {
                let result = await fetchUserListById(account.token, id);
                if (result) {
                    const admin_level = adminLevelList.find(item => item.value === result.data.user.admin_level.toString().toLowerCase().replace(/ /g, "_")); 
                    setFormData({
                        ...result.data.user,
                        admin_level: admin_level || null,
                        password: "", confirm_password: "",});
                }else {
                    navigate(UrlTypes.ADMIN_SUB_ADMIN_LIST);
                }
            })();
        }
        
        setModalLoading(false);
    }, [account, setModalLoading, id, navigate, adminLevelList]);

    const updateFormData = (key:string, value:any) => {
        setFormData({...formData, [key]:value});
    }

    const addSubAdminUser = async () => {
        if (!account) return;
        if (formData.firstname.length === 0 || formData.lastname.length === 0 || formData.username.length === 0 || formData.mobile.length === 0 || formData.email.length === 0 || (!id && (formData.password.length === 0 || formData.confirm_password.length === 0))) {
            toast("All fields are required");
            return;
        }
        if (formData.password !== formData.confirm_password) {
            toast("passwords doesn't match");
            return;
        }
        setModalLoading(true);
        let api_data:generalObj = {
            firstname: formData.firstname,
            lastname: formData.lastname,
            username: formData.username,
            mobile: formData.mobile,
            email: formData.email,
            password: formData.password,
            role: "Admin",
            admin_level: formData.admin_level ? formData.admin_level.value : null
        };

        let method = id ? "put" : "post";
        if (id) {
            api_data.id = id
        }

        let result = await addUser(account.token, api_data, method);
        if (result) {
            toast(result.message)
            navigate(UrlTypes.ADMIN_SUB_ADMIN_LIST);
        }
        setModalLoading(false);
    }

    return (
        <>
            <PageBodyHeader title="Add Sub Admin" desc="Add/Update Sub Admin" />

            <Card color="#676967" containerCardStyle={{overflow:"auto"}}>
                <>
                    <div className="mb-wrap" style={{display:'flex', gap:"24px", alignItems:"center"}}>
                        <InputField label={"Firstname"} inputProp={{value:formData.firstname}} onTextChange={(evt) => updateFormData("firstname", evt)} containerClass={"mb-w-100"} containerStyle={{width:"50%"}}  />
                        <InputField label={"Lastname"} inputProp={{value:formData.lastname}} onTextChange={(evt) => updateFormData("lastname", evt)} containerClass={"mb-w-100"} containerStyle={{width:"50%"}}  />
                    </div>
                    <div className="mb-wrap" style={{display:'flex', gap:"24px", alignItems:"center", marginTop:"20px"}}>
                        <InputField label={"Username"} inputProp={{value:formData.username}} onTextChange={(evt) => updateFormData("username", evt)} containerClass={"mb-w-100"} containerStyle={{width:"50%"}}  />
                        <InputField label={"Mobile"} inputProp={{value:formData.mobile}} onTextChange={(evt) => updateFormData("mobile", evt)} containerClass={"mb-w-100"} containerStyle={{width:"50%"}}  />
                    </div>

                    <div className="mb-wrap" style={{display:'flex', gap:"24px", alignItems:"center", marginTop:"20px"}}>
                        <InputField label={"Email"} inputProp={{value:formData.email, type:"email"}} onTextChange={(evt) => updateFormData("email", evt)} containerClass={"mb-w-100"} containerStyle={{width:"50%"}} />
                        <InputDropdown label={"Admin Level"} data={adminLevelList} placeHolder="Select all that apply" selectedData={formData.admin_level} mulitple={false} containerClass={"mb-w-100"} containerStyle={{width:"50%"}} onItemChange={(val) => updateFormData("admin_level", val)} />
                    </div>

                    <div className="mb-wrap" style={{display:'flex', gap:"24px", alignItems:"center", marginTop:"20px"}}>
                        <InputField label={"Password"} inputProp={{value:formData.password, type:`${formData.secure_entry ? "password" : "text"}`}} onTextChange={(evt) => updateFormData("password", evt)} containerClass={"mb-w-100"} containerStyle={{width:"50%"}} isIconRight={formData.secure_entry ? <FiEyeOff size={16} color="#999C99" /> : <FiEye size={16} color="#999C99" />} iconPress={() => updateFormData("secure_entry", !formData.secure_entry)}  />
                        <InputField label={"Confirm Password"} inputProp={{value:formData.confirm_password, type:`${formData.secure_entry ? "password" : "text"}`}} onTextChange={(evt) => updateFormData("confirm_password", evt)} containerClass={"mb-w-100"} containerStyle={{width:"50%"}} isIconRight={formData.secure_entry ? <FiEyeOff size={16} color="#999C99" /> : <FiEye size={16} color="#999C99" />} iconPress={() => updateFormData("secure_entry", !formData.secure_entry)}  />
                    </div>

                    <div style={{marginTop:"44px", display:"flex", alignItems:'center', gap:"20px"}}>
                        <ButtonFrame btn_text="Submit" btn_style={{padding:"12px 24px", borderRadius:"8px", backgroundColor:"#00983A", color:"#FFF", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => addSubAdminUser()} />
                        <ButtonFrame btn_text="Cancel" btn_style={{padding:"12px 24px", borderRadius:"8px", border:"1px solid #808280", color:"#808280", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => window.history.back()} />
                    </div>

                </>
            </Card>
        </>
    )
}

export default AddSubAdmin;